import { TextField, FormHelperText } from '@mui/material';

import TextFieldContainer from './CustomTextField.style';

type PropsType = {
  isRequired?: boolean;
  isTouched?: boolean;
  multiline?: boolean;
  rows?: number;
  nameTextField: string;
  value: string;
  errorText?: string;
  label?: string;
  placeholder?: string;
  className?: string;
  isDisabled?: boolean;
  autoFocus?: boolean;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onChangeValue?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClick?: () => void;
};

const CustomTextField: React.FC<PropsType> = ({
  isRequired = false,
  isTouched,
  multiline,
  rows,
  nameTextField,
  value,
  errorText,
  label,
  placeholder,
  className,
  isDisabled,
  autoFocus,
  onBlur,
  onChangeValue,
  onClick,
}) => {
  const isErrorDisplay = isTouched && Boolean(errorText);

  return (
    <TextFieldContainer onClick={onClick} className={className}>
      <TextField
        id={nameTextField}
        label={label}
        placeholder={placeholder}
        error={isErrorDisplay}
        required={isRequired}
        value={value}
        onChange={onChangeValue}
        onBlur={onBlur}
        variant="outlined"
        rows={rows}
        multiline={multiline}
        disabled={isDisabled}
        autoFocus={autoFocus}
      />

      {isErrorDisplay && <FormHelperText error={isErrorDisplay}>{errorText}</FormHelperText>}
    </TextFieldContainer>
  );
};

export default CustomTextField;
